import _default from './Flag';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Flag/index.js
// module id = 393
// module chunks = 0